export const VERSION = '3.4.2'; // n_version,month,week
export const COMPANY_NAME = 'Treinco';
export const DEVICE_TYPES = Object.freeze({
  ALARM: 'alarm',
  CCTV: 'cctv',
  GPS: 'gps',
  ROUND: 'round',
  TREINCO_APP: 'treinco-app',
});
//TODO implement event types in settings event
export const EVENT_TYPES = Object.freeze({
  USER: 'user',
  ZONE: 'zone',
  RECEIVER_LINE: 'receiver-line',
  TOUR: 'tour',
  NONE: null,
});
export const COLORS = Object.freeze([
  '#FF8C42', // Bright orange
  '#D64550', // Rich red
  '#FFD700', // Vibrant yellow
  '#C3A6E2', // Soft purple
  '#77D6B2', // Muted green-blue
  '#F4B7B9', // Light pink
  '#2A3D66', // Deep blue
  '#E4B500', // Warm, earthy yellow
  '#FF6B6B', // Bright coral red
  '#6B8E23', // Muted green
]);

// Keep in sync with src/common/notificationTypes.js - this file cannot import
// from common (the frontend is not an npm workspace).
export const NOTIFICATION_TYPES = Object.freeze({
  TREINCO_APP_PUSH: 'treinco_app_push',
  TELEGRAM: 'telegram',
  EMAIL: 'email',
  SMS: 'sms',
});

// Keep in sync with src/common/notificationTypes.js. The first one is the
// default, and what every notification created before the field existed is.
export const NOTIFICATION_LANGUAGES = Object.freeze(['es', 'en']);

export const TIMER_ACTION_TYPES = Object.freeze({
  INACTIVITY_EVENT: 'event_inactivity',
  INACTIVITY_POSITION: 'position_inactivity',
  STOP_POSITION_LIMIT: 'position_stop_limit',
  GENERATE_EVENT: 'generate_event',
});

export const RECEIVER_CONNECTION_TYPES = Object.freeze({
  SERIAL: 'serial',
  TCP_CLIENT: 'tcp_client',
  TCP_SERVER: 'tcp_server',
  UDP: 'udp',
  HTTP_SERVER: 'http_server',
  POLLING: 'polling',
});

export const DAHUA_RECEIVER_ID = '47e0812a-3457-41e7-97a3-186ea21ab85e';
export const TRACCAR_RECEIVER_ID = '7a0f714f-99a5-47fc-8a99-17a4c524e160';
export const RISCO_RECEIVER_ID = 'c8b97556-db94-4a10-b255-0be799c15736';

export const REPORTER_ROLES_BY_RESOURCE = {
  DEVICE: '2816be99-fa26-4034-9717-7c9fe119f942',
};
